module.exports = __webpack_public_path__ + "static/media/act-5.a1b8bb13.mp3";